import React from 'react';
import useLanguage from '../hooks/useLanguage';
import MapEmbed from '../components/location/MapEmbed';
import LocationInfo from '../components/location/LocationInfo';

/**
 * Location Page
 * Displays company location map and detailed directions
 */
const Location = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page Header */}
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            {language === 'ko' ? '오시는 길' : 'Location'}
          </h1>
          <p className="text-lg md:text-xl text-blue-100 max-w-2xl mx-auto">
            {language === 'ko'
              ? '저희 회사를 방문하실 때 참고하시기 바랍니다.'
              : 'Please refer to this information when visiting our company.'}
          </p>
        </div>
      </section>

      {/* Map Section - Full Width */}
      <section className="py-12 md:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <MapEmbed />
        </div>
      </section>

      {/* Location Information Section */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <LocationInfo />
        </div>
      </section>
    </div>
  );
};

export default Location;
